import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const studentRoutes = [
  {
    path: '/student/login',
    name: 'Login',
    component: () => import('../views/student/Login.vue'),
    meta: {
      navBarTitle: 'ログイン - 修了生',
      requiresAuth: false
    }
  },
  {
    path: '/student/',
    name: 'Top',
    component: () => import('../views/student/Top.vue'),
    meta: {
      navBarTitle: 'トップ',
      requiresAuth: true
    }
  },
  {
    path: '/student/announcements',
    name: 'Announcements',
    component: () => import('../views/student/Announcements.vue'),
    meta: {
      navBarTitle: 'お知らせ',
      requiresAuth: true
    }
  },
  {
    path: '/student/Achievements',
    name: 'Achievements',
    component: () => import('../views/student/Achievements.vue'),
    meta: {
      navBarTitle: '成果',
      requiresAuth: true
    }
  },
  {
    path: '/student/Portofolios',
    name: 'Portofolios',
    component: () => import('../views/student/Portofolios.vue'),
    meta: {
      navBarTitle: 'ポートフォリオ',
      requiresAuth: true
    }
  },
  {
    path: '/student/profile',
    name: 'Profile',
    component: () => import('../views/student/Profile.vue'),
    meta: {
      navBarTitle: 'プロフィール',
      requiresAuth: true
    }
  },
  {
    path: '/student/configs',
    name: 'Configs',
    component: () => import('../views/student/Configs.vue'),
    meta: {
      navBarTitle: '設定',
      requiresAuth: true
    }
  },
  {
    path: '/student/terms',
    name: 'StudentTerms',
    component: () => import('../components/Terms.vue'),
    meta: {
      navBarTitle: '利用規約',
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      navBarTitle: '404',
      requiresAuth: false
    }
  }
]

const adminRoutes = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/Login.vue'),
    meta: {
      navBarTitle: 'ログイン - 運営者',
      requiresAuth: false
    }
  },
  {
    path: '/admin/',
    name: 'AdminTop',
    component: () => import('../views/admin/Top.vue'),
    meta: {
      navBarTitle: 'トップ',
      requiresAuth: true
    }
  },
  {
    path: '/admin/announcements',
    name: 'AdminAnnouncements',
    component: () => import('../views/admin/Announcements.vue'),
    meta: {
      navBarTitle: 'お知らせ',
      requiresAuth: true
    }
  },
  {
    path: '/admin/achievements',
    name: 'AdminAchievements',
    component: () => import('../views/admin/Achievements.vue'),
    meta: {
      navBarTitle: '成果',
      requiresAuth: true
    }
  },
  {
    path: '/admin/configs',
    name: 'AdminConfigs',
    component: () => import('../views/admin/Configs.vue'),
    meta: {
      navBarTitle: '設定',
      requiresAuth: true
    }
  },
  {
    path: '/admin/students',
    name: 'Students',
    component: () => import('../views/admin/Students.vue'),
    meta: {
      navBarTitle: '修了生管理',
      requiresAuth: true
    }
  },
  {
    path: '/admin/administrators',
    name: 'Administrators',
    component: () => import('../views/admin/Administrators.vue'),
    meta: {
      navBarTitle: '運営者管理',
      requiresAuth: true
    }
  },
  {
    path: '/admin/terms',
    name: 'AdminTerms',
    component: () => import('../components/Terms.vue'),
    meta: {
      navBarTitle: '利用規約',
      requiresAuth: true
    }
  }
]

const portfolioRoutes = [
  {
    path: '/portfolio/:token',
    name: 'PortfolioTop',
    component: () => import('../views/portfolio/Top.vue'),
    meta: {
      navBarTitle: 'ポートフォリオ',
      requiresAuth: false
    }
  }
]

const termsRoutes = [
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../components/Terms.vue'),
    meta: {
      navBarTitle: '利用規約',
      requiresAuth: false
    }
  }
]

const routes = studentRoutes.concat(adminRoutes.concat(portfolioRoutes.concat(termsRoutes)))
const router = new VueRouter({
  routes
})

// ナビゲーションガード
router.beforeEach((to, from, next) => {
  // #がurlとして使えないサイトからのアクセスは、NotFoundに飛んでしまうので、指定されたページにリダイレクトする(Typetalk連携用)
  const params = location.search.match(/^\?page=(.*?)($|&)(.*)/)
  if (to.name === 'NotFound' && !to.query.navigated && params && params[1]) {
    const query = { navigated: true }
    if (params[3]) {
      params[3].split('&').forEach((param) => {
        const split = param.split('=')
        query[split[0]] = split[1]
      })
    }
    next({ path: params[1], query: query })
  } else {
    next()
  }

  // 認証必須
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/isLoggedIn']) {
      // 未ログイン = ログアウト
      store.dispatch('auth/logout')
      next(to.path.toLowerCase().includes('/admin') ? '/admin/login' : '/student/login')
    } else if (to.path.toLowerCase().includes('/admin') !== store.getters['auth/loginUserAdminStatus']) {
      // ログイン済, AdminStatusが一致しない = 一致するトップに遷移
      next(Number(store.getters['auth/loginUserAdminStatus']) ? '/admin' : '/student')
    } else {
      next()
    }
  } else {
    // ログイン済, ログイン画面にアクセス = トップに遷移
    if (store.getters['auth/isLoggedIn'] && to.path.toLowerCase().includes('/login')) {
      next(Number(store.getters['auth/loginUserAdminStatus']) ? '/admin' : '/student')
    } else {
      next()
    }
  }
})

export default router
